import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { Button } from '@uncinc/uncinc-react-kitchen-sink';
import { SearchReset } from '@uncinc/react-searchkit';
import type { SearchResetProps } from '@uncinc/react-searchkit/dist/components/Reset';

const TextButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = ({
  className,
  ...props
}) => (
  <Button
    primary={false}
    className={c('Button--text', className)}
    {...props}
  />
);

const SearchResetButton: React.FC<SearchResetProps> = (props) => {
  const { t } = useTranslation();

  return (
    <SearchReset
      button={TextButton}
      buttonText={t('components.search.facets.reset')}
      {...props}
    />
  );
};

export default SearchResetButton;
